import { action, makeAutoObservable } from "mobx"
import {
    MenuCategory,
    MenuItem,
    MenuItemModifierSet,
} from "../../../../services/menu/models";
import { LocalizedString } from "../../../../services/general/models";
import { MenuFormType } from "../menu/forms";

export enum ModifiersFormType {
    createMenuCategory = "createMenuCategory",
    deleteMenuCategory = "deleteMenuCategory",
    createMenuItem = "createMenuItem",
    copyMenuItem = "copyMenuItem",
    editMenuItem = "editMenuItem",
    deleteMenuItem = "deleteMenuItem",
    editMenuModifiersSet = 'editMenuModifiersSet',
    deleteMenuModifiersSet = 'deleteMenuModifiersSet',
    editCategoriesForm = 'editCategoriesForm',
    editItemsOrdersForm = 'editItemsOrdersForm',
}

export enum FormDisplayType {
    popup = "popup",
    inline = "inline"
}

class ModifiersFormStore {
    forms: {
        [ModifiersFormType.editMenuModifiersSet]: {
            current?: MenuItemModifierSet,
            type: FormDisplayType,
            open: boolean,
            init: {name?: string},
            notifyOnDone?: (modifierSetId: number) => void;
        },
        [ModifiersFormType.deleteMenuModifiersSet]: {
            current?: MenuItemModifierSet,
            type: FormDisplayType,
            open: boolean,
        },

    } = {
        [ModifiersFormType.editMenuModifiersSet]: {
            type: FormDisplayType.popup,
            open: false,
            init:{}
        },
        [ModifiersFormType.deleteMenuModifiersSet]: {
            type: FormDisplayType.popup,
            open: false,
        },
    };

    constructor() {
        makeAutoObservable(this);
    }

    @action
    showPopupForm(type: ModifiersFormType, current?: any) {
        this.forms[type].open = true;
        this.forms[type].current = current;
        this.forms[type].type = FormDisplayType.popup;
    }

    @action
    closeForm(type: ModifiersFormType) {
        this.forms[type].open = false;
        this.forms[type].current = undefined;
    }
    @action
    setModifiersSetInitDataAndNotify(
        params: Partial<{ name: string}>,
        notify: (modifierSetId: number) => void
    ) {
        this.forms[ModifiersFormType.editMenuModifiersSet].init = {
            name: params.name,
        };
        this.forms[ModifiersFormType.editMenuModifiersSet].notifyOnDone = notify;
    }

}

export default ModifiersFormStore
